export default __webpack_public_path__ + "static/media/09.cc85fc12.webp";